module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.navType,
    attrs: {
      "id": "Web_Nav"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historyBack),
      expression: "historyBack"
    }],
    staticClass: "history-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    staticClass: "back-img",
    attrs: {
      "src": require("../../assets/icon/image_nav_back_arrow@3x.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountShow),
      expression: "accountShow"
    }],
    staticClass: "account",
    attrs: {
      "disabled": ""
    },
    on: {
      "click": _vm.historyShow
    }
  }, [(!_vm.haveUserName) ? _c('input', {
    staticClass: "hidden-input",
    attrs: {
      "type": "text"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "back-inner"
  }, [_c('a', {}, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userImgShow),
      expression: "userImgShow"
    }],
    staticClass: "user-img",
    attrs: {
      "src": _vm.userImg
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userImgShow),
      expression: "!userImgShow"
    }],
    staticClass: "userImg",
    attrs: {
      "src": require("../../assets/icon/image_instagram_placeholder@3x.png")
    }
  })])]), _vm._v(" "), _c('img', {
    staticClass: "down-img",
    attrs: {
      "src": require("../../assets/icon/image_nav_account_arrow@3x(1).png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(_vm._s(this.titleName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.coinShow),
      expression: "coinShow"
    }],
    staticClass: "userCoins"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/image_gx_coins@3x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userCoins))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collectShow),
      expression: "collectShow"
    }],
    staticClass: "collect",
    on: {
      "click": _vm.addHome
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bd8d485"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/WebNavBar.vue
// module id = 267
// module chunks = 18